import { useState } from 'react';
import { Package } from 'lucide-react';
import { cn } from '@/lib/utils';

interface AppIconProps {
  iconSrc: string | null;
  appName: string;
  className?: string;
}

export const AppIcon = ({ iconSrc, appName, className }: AppIconProps) => {
  const [error, setError] = useState(false);
  
  if (!iconSrc || error) {
    return (
      <div className={cn("rounded bg-muted flex items-center justify-center", className)}>
        <Package className="h-3 w-3 text-muted-foreground" />
      </div>
    );
  }
  
  return (
    <img 
      src={iconSrc} 
      alt={appName}
      className={cn("rounded object-contain", className)}
      onError={() => setError(true)}
    />
  );
};
